// src/environments/environment.dev.ts
export const environment = {
  production: false,
  chatApiUrl: 'https://nubo-caht-api-dev-b7c0cxgmdggrc9ed.northeurope-01.azurewebsites.net/api',
  //chatApiUrl: 'http://localhost:5136/api',
  customizationApiUrl: 'https://nubo-api-dev-hadae4gpc6f2erb4.northeurope-01.azurewebsites.net/api/configs/customization'
};